import {
  MaterialReactTable,
  MRT_ActionMenuItem,
  MRT_ColumnDef,
  useMaterialReactTable,
} from 'material-react-table';
import { FC } from 'react';
// import UnlinkIcon from '@/assets/unlink.svg';
import ViewIcon from '@/assets/view.svg';
// import { Button } from '@/components/ui/button';
import { Drawer, DrawerProps } from '@/components/ui/drawer';
// import { Modal } from '@/components/ui/modal';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { strings } from '@/constants/strings';
import { useOpenState } from '@/hooks/use-open-state';
import { useResidentsInCurrentUnit } from '@/hooks/use-residents';
// import { api } from '@/redux/api';
import { composeTableOptions } from '@/table';
import { Resident } from '@/types/resident';
import { ViewResident } from '../../drawer-views/view-resident';

const columns: MRT_ColumnDef<Resident>[] = [
  {
    accessorKey: 'name',
    header: 'Resident Name',
    grow: true,
    size: 150,
  },
  {
    accessorKey: 'identifier',
    header: 'Identifier',
    size: 150,
  },
  {
    accessorKey: 'externalId',
    header: 'External ID',
    size: 150,
  },
];

type OpenContext = { resident: Resident };

type DrawerView = 'view';

type DrawerContext = { view: DrawerView } & Partial<OpenContext>;

export const ResidentsView: FC = () => {
  const { data: residents, isLoading: isLoadingResidents } =
    useResidentsInCurrentUnit();
  const {
    state: drawerState,
    open: openDrawer,
    toggleOpen: toggleDrawerOpen,
  } = useOpenState<DrawerContext>({ view: 'view' });
  // TODO: add when it's possible to unassociate a resident from a unit
  // const {
  //   state: unassociateResidentConfirmationState,
  //   open: openUnassociateResidentConfirmation,
  //   toggleOpen: toggleUnassignResidentConfirmationOpen,
  // } = useOpenState<Partial<OpenContext>>({});
  // const [removeResidentFromUni] = api.useRemoveResidentFromUnitMutation();

  const table = useMaterialReactTable({
    ...composeTableOptions<Resident>({ enableRowActions: true }),
    columns,
    enableColumnResizing: true,
    data: residents,
    state: {
      isLoading: isLoadingResidents,
      ...(isLoadingResidents
        ? {
            pagination: {
              pageIndex: 0,
              pageSize: 1,
            },
          }
        : {}),
    },
    renderRowActionMenuItems: ({ row, table, closeMenu }) => [
      <MRT_ActionMenuItem
        icon={<ViewIcon />}
        key="view"
        label="View"
        onClick={() => {
          closeMenu();
          openDrawer({ view: 'view', resident: row.original });
        }}
        table={table}
      />,
      // <MRT_ActionMenuItem
      //   key="unlink"
      //   label="Unassociate"
      //   icon={<UnlinkIcon />}
      //   table={table}
      //   onClick={() => {
      //     closeMenu();
      //     openUnassociateResidentConfirmation({ resident: row.original });
      //   }}
      // />,
    ],
  });

  const getDrawerTitleProps = (): Pick<DrawerProps, 'title' | 'subtitle'> => {
    switch (drawerState.context.view) {
      case 'view':
        return {
          title: strings.unit.residents.drawer_view.title,
        };
      default:
        return {
          title: '',
        };
    }
  };

  const renderDrawerContent = () => {
    switch (drawerState.context.view) {
      case 'view': {
        const { resident } = drawerState.context;
        if (resident) {
          return (
            <ViewResident
              onClose={() => toggleDrawerOpen(false)}
              resident={resident}
            />
          );
        }
        break;
      }
      default:
        break;
    }

    if (drawerState.open) {
      toggleDrawerOpen(false);
    }
    return null;
  };

  return (
    <>
      <div>
        {/* TODO: use SectionContainerLayout */}
        <SectionHeadingGroup
          className="mb-6"
          subtitle="A list of all the residents associated with this unit."
          title="Associated Residents"
        />
        <MaterialReactTable table={table} />
      </div>
      <Drawer
        {...getDrawerTitleProps()}
        open={drawerState.open}
        setOpen={toggleDrawerOpen}
      >
        {renderDrawerContent()}
      </Drawer>
      {/* <Modal
        buttonItems={[
          <Button
            key="cancel"
            variant="secondary"
            onClick={() => toggleUnassignResidentConfirmationOpen(false)}
          >
            {strings.residents.modal_confirm_unassociate.cancel}
          </Button>,
          <Button
            key="delete"
            variant="primary-warning"
            onClick={() => {
              const { resident } = unassociateResidentConfirmationState.context;
              if (resident) {
                removeResidentFromUni({
                  resident,
                });
              }
              toggleUnassignResidentConfirmationOpen(false);
            }}
          >
            {strings.residents.modal_confirm_unassociate.unassociate}
          </Button>,
        ]}
        title={strings.residents.modal_confirm_unassociate.title}
        description={strings.residents.modal_confirm_unassociate.description}
        open={unassociateResidentConfirmationState.open}
        setOpen={toggleUnassignResidentConfirmationOpen}
      /> */}
    </>
  );
};
